export default __webpack_public_path__ + "static/media/segment_usage.fa04091a.png";